import React from 'react';
import PropTypes from 'prop-types';
import { moneyFormat } from '@4beefopag/4bee-fopag-core/dist/util';
import { TabelaAtosCooperativos } from './styles';

function CooperativeActsTable({ acts }) {
  if (!acts || acts.length === 0) {
    return null;
  }

  return (
    <TabelaAtosCooperativos>
      <tbody>
        {acts.map((ato) => (
          <tr key={ato.codigo}>
            <td
              width="200px"
              style={{ paddingLeft: '20px' }}
            >
              {ato.codigo}
            </td>
            <td width="400px">{ato.descricao}</td>
            <td>{moneyFormat(ato.valor)}</td>
          </tr>
        ))}
      </tbody>
    </TabelaAtosCooperativos>
  );
}

CooperativeActsTable.propTypes = {
  acts: PropTypes.arrayOf(
    PropTypes.shape({
      codigo: PropTypes.string,
      descricao: PropTypes.string,
      valor: PropTypes.number,
    })
  ),
};

CooperativeActsTable.defaultProps = {
  acts: undefined,
};

export default CooperativeActsTable;
